import { types as coreTypes } from '@sitebuilder/core';

export interface IPublicComponentApiClient {
    getPublicComponent(
        libraryName: string,
        componentId: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<coreTypes.PublicComponent>;

    listPublicComponents(
        libraryName: string,
        folderName: string,
        getDeleted: boolean,
        options?: { originalHostname?: string; accessToken?: string },
        filters?: { [key: string]: string },
        sort?: { field?: string; dir?: string }
    ): Promise<any[]>;
}

export class PublicComponentApiClient implements IPublicComponentApiClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private getHeaders(
        h: {
            [key: string]: string;
        },
        options?: { accessToken?: string }
    ) {
        const headers: {
            [key: string]: string;
        } = {};

        if (typeof options?.accessToken === 'string' && options.accessToken.length > 0) {
            headers.Authorization = `bearer ${options.accessToken}`;
        }

        return { ...headers, ...h };
    }

    async getPublicComponent(
        libraryName: string,
        componentId: string,
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${
            this.baseUrl || ''
        }/api/components/${libraryName}/${componentId}?isPublic=true`;

        const res = await fetch(url, {
            method: 'GET',
            headers: this.getHeaders({}, options),
        });

        const component = await res.json();
        return component as coreTypes.PublicComponent;
    }

    async listPublicComponents(
        libraryName: string,
        folderName: string,
        getDeleted: boolean,
        options?: { originalHostname?: string; accessToken?: string },
        filters?: { [key: string]: string | Record<string, unknown> | string[] },
        sort?: { field?: string; dir?: string },
        take?: number,
        skip?: number
    ) {
        const url = folderName
            ? `${this.baseUrl || ''}/api/admin/components/list/${libraryName}${folderName}`
            : `${this.baseUrl || ''}/api/admin/components/${libraryName}`;

        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                deleted: getDeleted,
                sortBy: sort?.field || 'Id',
                sortDirection: sort?.dir || 'asc',
                take: take || 25,
                skip: skip || 0,
                ...filters,
                isPublic: true,
            }),
        });

        const components = await res.json();
        return components;
    }
}
